import { AccountState } from '../store/account/types';
import { AppState } from '../store';
import { useSelector } from 'react-redux';
import SignInPage from '../pages/login';
import LayoutAdmin from '../pages/LayoutAdmin';
import AccountPage from '../pages/account/AcountList';
import { AdminDashboardPage } from '../pages/dashboard';
import { Navigate, useLocation } from 'react-router-dom';

const STAFF_ALLOWED_ROUTES = [
  '/salon',
  '/accounts',
  '/employees',
  '/customers',
  '/sms',
  '/promotions',
  '/coupons',
  '/gift-card',
  '/marketing',
  '/setting',
  '/credit-card',
];

const canAccessStaffRoute = (pathname: string) => {
  return STAFF_ALLOWED_ROUTES.some(
    route =>
      pathname === route ||
      pathname.startsWith(`${route}/`)
  );
};

export const PrivateRoute = ({ children, noneFooter }: { children: React.ReactNode, noneFooter?: boolean }) => {
    const account: AccountState = useSelector((state: AppState) => state.account);
    const location = useLocation();

    
    if (account.token) {
        const isAdmin = account.role === 'ADMIN';

        if (!isAdmin && !canAccessStaffRoute(location.pathname)) {
            return <Navigate to="/accounts" replace state={{ from: location }} />;
        }

        if (children === null) {
            return <LayoutAdmin> {<AdminDashboardPage />} </LayoutAdmin>
        } else {
            return <LayoutAdmin noneFooter={noneFooter}> {children} </LayoutAdmin>
        }
    } else {
        return <SignInPage />
    }
};